import React from 'react';
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';
import Form from 'react-bootstrap/Form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';

import { IContentService, IContentListEntry } from '../services/ContentService';
import ContentListEntryComponent from './ContentListEntryComponent';
import { Pagination } from 'react-bootstrap';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

export default class ContentList extends React.Component<{
    contentService: IContentService;
}> {
    constructor(props: { contentService: IContentService }) {
        super(props);

        this.state = {
            contentList: [],
            filteredList: [],
            searchFilters: {
                contentId: '',
                title: '',
                mainLibrary: ''
            },
            currentPage: 1,
            itemsPerPage: 5,
            useSearchFilters: false
        };
        this.contentService = props.contentService;
    }

    public state: {
        contentList: IContentListEntry[];
        filteredList: IContentListEntry[];
        searchFilters: {
            contentId: string;
            title: string;
            mainLibrary: string;
        };
        currentPage: number;
        itemsPerPage: number;
        useSearchFilters: boolean;
    };

    handlePageChange = (pageNumber) => {
        this.setState({ currentPage: pageNumber });
    };

    toggleSearchFilters = () => {
        this.setState({ useSearchFilters: !this.state.useSearchFilters });
    };

    protected contentService: IContentService;
    protected newCounter = 0;

    public async componentDidMount(): Promise<void> {
        await this.updateList();
    }

    public render(): React.ReactNode {
        const { filteredList, currentPage, itemsPerPage, useSearchFilters } =
            this.state;
        const indexOfLastItem = currentPage * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        const currentItems = filteredList.slice(
            indexOfFirstItem,
            indexOfLastItem
        );
        return (
            <div>
                {/* Search Bar */}
                <Form className="mb-3">
                    <Form.Check
                        type="switch"
                        id="useSearchFiltersSwitch"
                        label="Use Search Filters"
                        checked={useSearchFilters}
                        onChange={this.toggleSearchFilters}
                    />
                    {useSearchFilters && (
                        <>
                            <Form.Group className="mb-2">
                                <Form.Label>Search by Content ID</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Content ID"
                                    value={this.state.searchFilters.contentId}
                                    onChange={(e) =>
                                        this.updateSearchFilter(
                                            'contentId',
                                            e.target.value
                                        )
                                    }
                                />
                            </Form.Group>
                            <Form.Group className="mb-2">
                                <Form.Label>Search by Title</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Title"
                                    value={this.state.searchFilters.title}
                                    onChange={(e) =>
                                        this.updateSearchFilter(
                                            'title',
                                            e.target.value
                                        )
                                    }
                                />
                            </Form.Group>
                            <Form.Group className="mb-2">
                                <Form.Label>Search by Main Library</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Main Library"
                                    value={this.state.searchFilters.mainLibrary}
                                    onChange={(e) =>
                                        this.updateSearchFilter(
                                            'mainLibrary',
                                            e.target.value
                                        )
                                    }
                                />
                            </Form.Group>
                        </>
                    )}
                    {useSearchFilters && (
                        <Button
                            variant="primary"
                            onClick={this.applySearch}
                            className="mt-2"
                        >
                            Apply Search
                        </Button>
                    )}
                </Form>

                <Button
                    variant="primary"
                    onClick={() => this.new()}
                    className="my-2"
                >
                    <FontAwesomeIcon
                        icon={faPlusCircle as IconProp}
                        className="me-2"
                    />
                    Create new content
                </Button>
                <ListGroup>
                    {currentItems.map((content) => (
                        <ContentListEntryComponent
                            contentService={this.contentService}
                            data={content}
                            key={content.originalNewKey ?? content.contentId}
                            onDiscard={() => this.onDiscard(content)}
                            onDelete={() => this.onDelete(content)}
                            onSaved={(newData) =>
                                this.onSaved(content, newData)
                            }
                            generateDownloadLink={
                                this.contentService.generateDownloadLink
                            }
                            generateUploadLink={
                                this.contentService.generateUploadLink
                            }
                        />
                    ))}
                </ListGroup>
                <Pagination className="mt-3">
                    {Array.from(
                        {
                            length: Math.ceil(
                                filteredList.length / itemsPerPage
                            )
                        },
                        (_, index) => (
                            <Pagination.Item
                                key={index + 1}
                                active={index + 1 === currentPage}
                                onClick={() => this.handlePageChange(index + 1)}
                            >
                                {index + 1}
                            </Pagination.Item>
                        )
                    )}
                </Pagination>
            </div>
        );
    }

    protected async updateList(): Promise<void> {
        const contentList = await this.contentService.list();
        this.setState({ contentList, filteredList: contentList });
    }

    protected new() {
        const newContent = {
            contentId: 'new',
            mainLibrary: undefined,
            title: 'New H5P',
            originalNewKey: `new-${this.newCounter++}`
        };
        this.setState({
            contentList: [newContent, ...this.state.contentList],
            filteredList: [newContent, ...this.state.filteredList]
        });
    }

    protected onDiscard(content: IContentListEntry) {
        const updatedList = this.state.contentList.filter((c) => c !== content);
        this.setState({
            contentList: updatedList,
            filteredList: updatedList
        });
    }

    protected async onDelete(content: IContentListEntry) {
        if (!content.contentId) {
            return;
        }
        try {
            await this.contentService.delete(content.contentId);
            const updatedList = this.state.contentList.filter(
                (c) => c !== content
            );
            this.setState({
                contentList: updatedList,
                filteredList: updatedList
            });
        } catch (error) {
            if (error instanceof Error) {
                console.error(error.message);
            }
        }
    }

    protected async onSaved(
        oldData: IContentListEntry,
        newData: IContentListEntry
    ) {
        const updatedList = this.state.contentList.map((c) =>
            c === oldData ? newData : c
        );
        this.setState({
            contentList: updatedList,
            filteredList: updatedList
        });
    }

    protected updateSearchFilter(field: string, value: string) {
        const searchFilters = { ...this.state.searchFilters, [field]: value };
        this.setState({ searchFilters });
    }

    protected applySearch = () => {
        const { searchFilters, contentList } = this.state;
        console.log('contentList', contentList);
        const filteredList = contentList.filter((content) => {
            return (
                content.contentId.includes(searchFilters.contentId) &&
                content.title
                    .toLowerCase()
                    .includes(searchFilters.title.toLowerCase()) &&
                content.mainLibrary
                    .toLowerCase()
                    .includes(searchFilters.mainLibrary.toLowerCase())
            );
        });
        this.setState({ filteredList });
    };
}
